import BaseParagraph from "../baseComponents/baseParagraph.js";
import CL1 from "../assets/1_kanistar_regular_txt.svg";
import CL2 from "../assets/2_kanistar_plus_txt.svg";
import CL3 from "../assets/3_kanistar_premium_txt.svg";
import CL4 from "../assets/4_kanistar_ultra_txt.svg";
import BaseImage from "../baseComponents/baseImage.js";
import WelcomeText from "./WelcomeText.js";
import { useSelector } from "react-redux";
import useTier from "../customHooks/useTier.js";
import usePoints from "../customHooks/usePoints.js";
import useBootstrap from "../customHooks/useBootstrap.js"

const FuelCanisterGauge = ({ radius}) => {
  const [currentTier, nextTier] = useTier();
  const [, nextPoints] = usePoints();

  const userState = useSelector((state) => state.userState);

  const {trashold, classes} = useBootstrap();

 
  const totalNumberOfDigits = 4;
  const nextPointsInString = nextPoints.toString();
  const paddedPointsInString = nextPointsInString.padStart(
    totalNumberOfDigits,
    "0"
  );
  let pointsInArray = paddedPointsInString.split("").map((digit, index) => {
    return { index: index, digit: digit };
  });
  const gaugeWidth = radius / 1.25;

  const Canisters = { CL1, CL2, CL3, CL4 };
  const currentTierObradeno = {...currentTier, img: Canisters[`C${currentTier.code}`]}
  const nextTierObradeno = {...nextTier, img: Canisters[`C${nextTier.code}`]}

  return (
    <>
      <div className={`${classes.onOrAboveTrashold.show(false)}`}>
        <WelcomeText fontSize="1.6em" isCentered />
      </div>
      <BaseImage
        buildSrcFromConnection={false}
        src={nextTierObradeno.img}
        style={{
          width: `${gaugeWidth}px`,
          marginBottom: "30px",
          marginTop: "30px",
        }}
      />
      <div>
        <BaseParagraph style={{ fontSize: "1.6em" }}>
          currentNumberOfPoints
        </BaseParagraph>
        <span style={{ fontSize: "1.6em" }}>:</span>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: nextTierObradeno.color,
          width: `${gaugeWidth}px`,
          justifyContent: "space-around",
          borderRadius: "10px",
          marginTop: "10px",
          marginBottom: "10px",
          padding: "10px",
        }}
      >
        {pointsInArray.map((point, index, array) => (
          <span
            key={point.index}
            style={{
              backgroundColor: "white",
              width: `${gaugeWidth / 4}px`,
              display: "flex",
              justifyContent: "center",
              borderRadius: "5px",
              marginRight: index === array.length - 1 ? "0px" : "8px",
            }}
          >
            <BaseParagraph
              style={{
                borderTop: `2px solid ${nextTierObradeno.color}`,
                borderBottom: `2px solid ${nextTierObradeno.color}`,
                width: "80%",
                marginTop: "10%",
                marginBottom: "10%",
                textAlign: "center",
                color: nextTierObradeno.color,
                fontSize: "1.6em",
              }}
              bold
              translate={false}
            >
              {point.digit}
            </BaseParagraph>
          </span>
        ))}
      </div>
      <span style={{ textAlign: "center"  }}>
        <BaseParagraph style={{ fontSize: "1.6em", textAlign: "center" }}>
          yourStatusInNextPeriod
        </BaseParagraph>
        <span style={{ fontSize: "1.6em" }}>
          &nbsp;{userState.nextPeriod.tierName}
        </span>
        <span style={{ fontSize: "1.6em" }}>!</span>
      </span>
    </>
  );
};

export default FuelCanisterGauge;
